import type { CustomerMonthlyRollup, ForecastMonthAmount, ForecastMonthMetric } from '@/api/types'

export const MONTH_STRIP_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const

export const MONTH_METRIC_OPTIONS: Array<{ value: ForecastMonthMetric; label: string }> = [
  { value: 'committed', label: 'Committed' },
  { value: 'weighted', label: 'Weighted' },
  { value: 'upside', label: 'Upside' },
]

export function monthMetricAmount(
  row: ForecastMonthAmount | undefined,
  metric: ForecastMonthMetric,
): number {
  if (!row) return 0
  const raw = row[metric]
  const numeric = typeof raw === 'string' ? Number(raw) : raw
  return Number.isFinite(numeric) ? numeric : 0
}

export function amountsForMetric(
  months: ForecastMonthAmount[] | undefined,
  metric: ForecastMonthMetric,
): number[] {
  const byMonth = new Map((months ?? []).map((row) => [row.month, row]))
  return MONTH_STRIP_LABELS.map((_, index) => monthMetricAmount(byMonth.get(index + 1), metric))
}

/** Customer year total for the same metric shown on the month strip. */
export function customerYearTotalForMetric(
  customer: CustomerMonthlyRollup | undefined,
  metric: ForecastMonthMetric,
): number | null {
  if (!customer) return null
  const raw =
    metric === 'committed'
      ? customer.year_committed
      : metric === 'weighted'
        ? customer.year_weighted
        : customer.year_upside
  const numeric = typeof raw === 'string' ? Number(raw) : Number(raw)
  return Number.isFinite(numeric) ? numeric : 0
}
